


























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["account"]),
    components: {
    }
})
export default class ChartFour extends Vue {
    // canvas 饼状图
    option: any = {};
    @Prop([String, Date])
    dateTime!: string;
    year: string = ""
    moneyTotal: string[] = [];
    moneyAvg: string[] = [];
    monthTotal: string[] = [];
    monthAvg: string[] = [];
    areaArr: any[] = [];

    mounted() {
        this.year = this.dateTime;
        this.fetchData();
    }
    // 监听时间切换
    @Watch("dateTime")
    dateTimeChange(val: string) {
        this.year = val;
        this.fetchData();
    }
    // 获取表格数据
    fetchData() {
        this.areaArr = [];
        this.moneyTotal = [];
        this.moneyAvg = [];
        this.monthTotal = [];
        this.monthAvg = [];
        Vue.axios
            .post(`account/cac`, {
                endPeriod: this.year,
                accounterNo: this.$store.state.account.no,
            })
            .then(res => {
                for (let i = 0; i < res.data.length; i++) {
                    this.areaArr.push({ value: res.data[i].area });
                    this.moneyTotal.push(res.data[i].moneyTotal);
                    this.moneyAvg.push(res.data[i].moneyAvg);
                    this.monthTotal.push(res.data[i].monthTotal);
                    this.monthAvg.push(res.data[i].monthAvg);
                }
                this.loadChart();
            });
    }
    loadChart() {
        let color = "#333";
        this.option = {
            title: {
                text: "LTV趋势图",
                textStyle: {
                    color: color,
                    fontSize: "15"
                },
                left: "center",
                top: "8"
            },
            tooltip: {
                trigger: "axis",
                formatter: "{a0}: {c0}<br />{a1}: {c1}<br />{a2}: {c2}万元<br />{a3}: {c3}万元",
                axisPointer: {
                    type: "line",
                }
            },
            grid: {
                top: "60",
                bottom: "40",
                right: "100",
            },
            legend: {
                data: [
                    { name: "平均月数", icon: "circle" },
                    { name: "总月数", icon: "circle" },
                    { name: "平均钱数", icon: "circle" },
                    { name: "总钱数", icon: "circle" }
                ],
                textStyle: { fontSize: "12", color: color },
                itemWidth: 6,
                itemHeight: 6,
                orient: "vertical",
                right: "0",
                top: "35%",
            },
            xAxis: [
                {
                    type: "category",
                    data: this.areaArr,
                    axisLine: {
                        lineStyle: {
                            color: "#666"
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            color: "white"
                        }
                    },
                }
            ],
            yAxis: [
                {
                    type: "value",
                    offset: 10,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        lineStyle: {
                            color: "white"
                        }
                    },
                    axisLabel: {
                        formatter(value: string, index: number) {
                            if (index === 0) {
                                return value + " (万元)";
                            } else {
                                return value;
                            }
                        },
                        color: color
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#eeeeee"
                        }
                    }
                },
                {
                    type: "value",
                    show: false
                },
                {
                    type: "value",
                    show: false
                }
            ],
            series: [
                {
                    name: "平均月数",
                    type: "bar",                    
                    data: this.monthAvg,
                    yAxisIndex: 2,
                    itemStyle: {
                        normal: {
                            color: "#34c2c1"
                        }
                    },
                },
                {
                    name: "总月数",
                    yAxisIndex: 1,
                    type: "bar",                    
                    data: this.monthTotal,
                    itemStyle: {
                        normal: {
                            color: "#fd7645"
                        }
                    }
                },
                {
                    name: "平均钱数",
                    type: "bar",                    
                    data: this.moneyAvg,
                    itemStyle: {
                        normal: {
                            color: "#ffc339"
                        }
                    }
                },
                {
                    name: "总钱数",
                    type: "line",
                    data: this.moneyTotal,
                    lineStyle: {
                        normal: {
                            color: "#e02f12"
                        }
                    },
                }
            ]
        };
    }
}
